import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/artigo/cssbuy-spreadsheet-guia/page";
import GuiaDeCompras from "../pages/guia-de-compras/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artigo/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/guia-de-compras",
    element: <GuiaDeCompras />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;